import { Controller } from "stimulus";

// The dashboard AI chat drawer: opens and closes the panel, keeps the thread scrolled to the newest
// message, and holds the form busy from submit until the server swaps in a fresh one when the reply is done.
export default class extends Controller {
  static targets = ["panel", "scroller", "form", "input", "submit"];

  disconnect() {
    this.observer?.disconnect();
  }

  toggle() {
    this.panelTarget.classList.toggle("hidden");
    this.panelTarget.classList.toggle("flex");
    if (this.hasInputTarget && !this.panelTarget.classList.contains("hidden")) this.inputTarget.focus();
  }

  close() {
    this.panelTarget.classList.add("hidden");
    this.panelTarget.classList.remove("flex");
  }

  // The composer is ready the moment a chat (or a fresh form after a reply) lands in an open panel.
  inputTargetConnected(element) {
    if (!this.panelTarget.classList.contains("hidden")) element.focus();
  }

  scrollerTargetConnected(element) {
    this.observer?.disconnect();
    this.observer = new MutationObserver(() => this.scrollToEnd());
    this.observer.observe(element, { childList: true, subtree: true, characterData: true });
    this.scrollToEnd();
  }

  scrollToEnd() {
    if (this.hasScrollerTarget) this.scrollerTarget.scrollTop = this.scrollerTarget.scrollHeight;
  }

  keydown(event) {
    if (event.key === "Enter" && !event.shiftKey && !event.isComposing) {
      event.preventDefault();
      if (this.inputTarget.value.trim() !== "") this.formTarget.requestSubmit();
    }
  }

  submitStart() {
    this.setBusy(true);
  }

  // A rejected submit keeps the text and frees the form; an accepted one clears it and stays busy
  // until the finished reply swaps in a fresh form.
  submitEnd(event) {
    if (event.detail.success) {
      this.inputTarget.value = "";
    } else {
      this.setBusy(false);
    }
  }

  // readOnly rather than disabled, so the text still goes out with the submit that started this.
  setBusy(busy) {
    this.inputTarget.readOnly = busy;
    this.submitTarget.disabled = busy;
  }
}
